<template>
  <b-container fluid class="px-0 position-relative">
    <div class="position-absolute w-100 left top" style="z-index: 10">
      <b-row>
        <b-col class="header">
          <div class="navigation d-flex justify-content-between">
            <div class="d-flex">
              <a href="https://musicverse.org"><img class="logo" src="@/assets/musicverse-header-logo.png" /></a>
            </div>
            <b-nav pills class="d-none d-md-flex justify-content-center nav-landing align-items-center" >
              <b-nav-item :href="`${mv_url}/`">Home</b-nav-item>
              <b-nav-item :href="`${mv_url}/about-us/`">About us</b-nav-item>
              <b-nav-item :href="`${mv_url}/musicians/`">Musicians</b-nav-item>
              <b-nav-item :href="`${mv_url_wp}/blog/`">Blog</b-nav-item>
              <b-nav-item :href="`/#/donation-page`" >Mission Projects</b-nav-item>
              <b-nav-item :href="`/#/premium`" >Premium</b-nav-item>
              <b-nav-item >|</b-nav-item>
              <b-nav-item href="/#/register" >Sign Up</b-nav-item>
              <b-nav-item href="/#/login" >Log In</b-nav-item>
            </b-nav>
            <b-dropdown variant="link" class="d-flex d-sm-none" toggle-class="text-decoration-none d-flex" menu-class="bg-menu-dropdown" no-caret>
              <template #button-content class="">
                <font-awesome-icon :icon="['fas', 'bars']" size="2x" class="text-white" />
              </template>
              <b-dropdown-item to="/home" class="d-block d-sm-none text-white" :link-class="'text-white'">Dashboard</b-dropdown-item>
              <b-dropdown-item :href="`${mv_url}/about-us/`" class="text-white" :link-class="'text-white'">About us</b-dropdown-item>
              <b-dropdown-item :href="`${mv_url}/musicians/`" class="text-white" :link-class="'text-white'">Musicians</b-dropdown-item>
              <b-dropdown-item :href="`${mv_url_wp}/blog/`" class="text-white" :link-class="'text-white'">Blog</b-dropdown-item>
              <b-dropdown-item :href="`/#/donation-page`" :active="isDonationPage" class="text-white" :link-class="'text-white'">Mission Projects</b-dropdown-item>
              <b-dropdown-item :href="`/#/premium`" :active="isPremiumPage" class="text-white" :link-class="'text-white'">Premium</b-dropdown-item>
              <b-dropdown-item to="register" class="text-white" :link-class="'text-white'">Sign Up</b-dropdown-item>
              <b-dropdown-item to="login" class="text-white" :link-class="'text-white'">Log In</b-dropdown-item>

            </b-dropdown>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-carousel
      id="carousel-1"
      :interval="4000"
      fade
      background="#ababab"
      img-width="100vw"
      img-height="63%"
    >
      <b-carousel-slide :img-src="bgLanding" v-if="!isDonationPage && !isPremiumPage">
        <div class="d-flex flex-column w-57 " style="padding-bottom:8%">
          <span class="slider-title text-left">Login or Register</span>
        </div>
        <div class="slider-image-topup">
          <img src="@/assets/phone-slider.png" />
        </div>
      </b-carousel-slide>
      <b-carousel-slide :img-src="bgDonationsSlider" v-if="isDonationPage">
        <div class="d-flex flex-column w-51 " style="padding-bottom:8%">
          <span class="slider-title text-left">Missions</span>
          <p class="text-left" style="margin-bottom: 4px;">Donate to MusicVerse to support missions</p>
          <p class="text-left">MusicVerse is also a 501c3 organization that can provide tax deductible receipts for US donors</p>
        </div>

      </b-carousel-slide>
      <b-carousel-slide :img-src="bgSubscribeSlider" v-if="isPremiumPage">
        <div class="d-flex flex-column w-57 " style="padding-bottom:8%">
          <span class="slider-title text-left">Go Premium for as low as $1!</span>
          <p class="text-left">Enjoy listening to songs in full, listen to songs offline, and share to missions. Cancel anytime!</p>
          <div class="d-flex">
            <a @click="gotToRoute('subscribe')" class="learn-more " align="center" style="width: 210px;cursor:pointer">Go Premium</a>
          </div>
        </div>
        <div class="slider-image-subscribe">
          <img src="@/assets/person-subscribe.png" />
        </div>
      </b-carousel-slide>
    </b-carousel>
  </b-container>
</template>

<script>
import bgLanding from '@/assets/bg-landing.png';
import bgDonationsSlider from '@/assets/bg-donations-slider.jpg';
import bgSubscribeSlider from '@/assets/bg-subscribe-slider.png';
import {mapActions} from "vuex";
const MV_URL = process.env.MUSICVERSE_URL;
const MV_URL_WP = process.env.MUSICVERSE_URL_WP;

export default {
  name: "HeaderLanding",
  data: () => ({
    mv_url:MV_URL,
    mv_url_wp:MV_URL_WP,
    bgLanding:bgLanding,
    bgDonationsSlider:bgDonationsSlider,
    bgSubscribeSlider:bgSubscribeSlider,
  }),
  computed:{
    currentRoute() {
      return this.$route.name;
    },
    isDonationPage(){
      return this.currentRoute === 'DonationPageAnon';
    },
    isPremiumPage(){
      return this.currentRoute === 'PremiumPage';
    },
  },
  methods:{
    ...mapActions('NotificationModule', ['setNextPage']),
    gotToRoute(route = 'home'){
      this.setNextPage(route==='home'?'Dashboard':'SubscribePage');
      this.$router.push({ name: 'Registration' });
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HeaderLanding.vue